<script>


export default {
	name: 'BadStory1',
	props: ['alpha']
}
</script>



<template>
<div class="story small center" :style="{opacity: alpha}">
	<img class="image" src="../assets/bad/story9.jpg">
	<div class="mask"></div>
	<div class="border"></div>
</div>
</template>

<style lang="less" scoped>
@import "../styles/colors.less";
@import "../styles/fonts.less";

.story {
	float: left;
	position: relative;
	overflow: hidden;
	background: #000;
}

.small {
	width: 25vw;
	height: 25vw;
}

.image {
	width: 101%;
	height: 101%;
	position: absolute;
	background-size: cover;
	background-position: center;
	transition: all 300ms ease;
}

.mask {
	width: 100%;
	height: 102%;
	position: absolute;
	background: linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,0.5) 100%);
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	color: #fff;
}

.border {
	width: 100%;
	height: 100%;
	position: absolute;
	pointer-events: none;
	box-sizing: border-box;
	border: 0px solid @red;
	transition: all 200ms ease;
}


.center {

	.border {
		border: 14px solid #fff;
	}

}


</style>



// WEBPACK FOOTER //
// BadStory9.vue?59445065